import React from "react"
import { Link } from "gatsby"

import { FiCornerUpLeft } from "react-icons/fi"

const Product = ({ children }) => (
  <div className="product">
    <Link to="/produkty#grid">
      <h5 className="product__link">
        <FiCornerUpLeft style={{ marginRight: "0.25rem" }} />
        Powrót do listy produktów
      </h5>
    </Link>
    {children}
  </div>
)

export default Product
